import {FormattedMessage, useIntl} from 'react-intl'
import _get from 'lodash/get';
import { HashratesChart } from '~/sha256/Hashrates';
import TextBlock from '@/shared/ui/TextBlock';
import { getPower } from '@/shared/utils/formatters';

type WorkerHashratesProps = {
  workerName: string;
  workerData: any;
  className?: string;
}

const WorkerHashrates = (props: WorkerHashratesProps) => {
  const {  
    workerName,
    workerData = {},
  } = props;
  const intl = useIntl();
  const hashrate = getPower(_get(workerData, 'hashrate', 0));
  const hashrateAverage = getPower(_get(workerData, 'hashrate24h', 0));

  return (
    <>
      <div className="font-medium text-white text-base">
        <FormattedMessage id="hashrates" />
      </div>
      <div className="flex my-4 -mx-4 h-[56px]">
        <TextBlock
          rootClassName='mx-4'
          title={intl.formatMessage({ id: 'hashrates.current' })}
          value={hashrate.value}
          subValue={hashrate.suffix}
        />
        <TextBlock
          rootClassName='mx-4'
          title={intl.formatMessage({ id: 'hashrates.avg' })}
          value={hashrateAverage.value}
          subValue={hashrateAverage.suffix}
        />
      </div>
      <HashratesChart workerName={workerName} className="h-[188px]"/>
    </>
  );
}

export default WorkerHashrates;
